module.exports = __webpack_public_path__ + "img/logo-color@2x.59787278.png";